import styled from "styled-components";

const AboutLandingWrapper = styled.div`
  margin: 0 auto !important;

  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  ul li {
    list-style-type: circle;
    margin-left: 30px !important;
  }
  h1,
  h2 {
    text-align: center;
  }
  p {
    font-size: 14px;
    line-height: 1.55;
    text-decoration: none;
  }
  .about-us {
  }

  .about-us-title {
    font-weight: 700;
    font-size: 1.1rem;
    text-align: left;
  }
  .about-us-content {
    text-align: left;
  }

  min-height: 550px;
`;

export { AboutLandingWrapper };
